const key = 'storage-data-version'

export class StorageDataCompatibilityGuard {
    constructor(private storage: Storage) {}

    ensure = (version: string): void => {
        const current = this.storage.getItem(key)
        if (current !== version) {
            console.info('New storage data version. Clearing storage.')
            this.storage.clear()
            this.storage.setItem(key, version)
        }
    }
}
